.disabled {
  opacity: 0.5;
  pointer-events: none;
}

.infoText {
  color: var(--body-text-arrows-400);
  height: 40px;
  align-content: center;
}

gz-title + gz-form-field,
gz-title + gz-labeled-content,
gz-title + div {
  padding-top: 15px;
}

#action-field {
  position: relative;
  z-index: 0;
}

gz-labeled-content {
  &::part(content) {
    overflow: visible;
  }

  &::part(label) {
    --font-family: var(--font-family-secondary);
  }
}

gz-radio-group {
  display: flex;
}

#rule-settings-extensions-field {
  margin-left: 250px;

  gz-chips-generator-input {
    --chip-list-width: 240px;
    --input-height: 105px;
  }
}

.checkbox-with-input {
  display: flex;
  align-items: center;

  .checkbox-width {
    width: 410px;
  }

  .checkbox-width-320 {
    width: 320px;
  }
}

.multiple-dropdowns {
  display: flex;
  align-items: center;

  .first-dropdown-field {
    --form-field-label-width: 320px;
  }
  .second-dropdown-field {
    --form-field-label-width: 150px;
  }

  .first-dropdown-field + .second-dropdown-field {
    margin-left: 50px;
  }

  gz-dropdown {
    --form-field-input-width: 170px;
  }
}

#rule-scope-from-specific-field,
#rule-scope-to-specific-field {
  margin-top: calc(var(--spacer) * -4); // remove extra space
  margin-left: 50px;
}

gz-labeled-content {
  height: 18px;
}

.helper-text {
  margin-top: -20px;
}

gz-checkbox {
  width: auto;
}
